import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useSortable } from '@dnd-kit/sortable';
import { Box, Typography, IconButton, Stack, Divider } from '@mui/material';
import React, { useState, useEffect } from 'react';
import defaultAlbumThumbnail from '../../assets/default_album_thumbnail.svg';
import theme from '../../theme';
import CloseIcon from '@mui/icons-material/Close';
import AlbumTitleLink from '../../components/common/AlbumTitleLink';

const SortableItem = ({ item, index, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: item.sourceId,
  });

  const [imageSrc, setImageSrc] = useState(item.albumImageUrl || defaultAlbumThumbnail);

  useEffect(() => {
    setImageSrc(item.albumImageUrl || defaultAlbumThumbnail);
  }, [item.albumImageUrl]);

  const handleError = () => {
    setImageSrc(defaultAlbumThumbnail);
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '20px',
    userSelect: 'none',
    height: '120px',
    backgroundColor: theme.palette.grey.bg,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes}>
      <Box {...listeners} sx={{ cursor: 'grab', display: 'flex', alignItems: 'center', mr: 2, touchAction: 'none' }}>
        <DragIndicatorIcon sx={{ width: '24px', height: '24px', color: theme.palette.black[3] }} />
      </Box>
      <Box sx={{ marginRight: 2, width: '20px' }}>
        <Typography variant="body4" sx={{ fontWeight: 'bold', fontColor: theme.palette.black[9] }}>
          {index + 1}
        </Typography>
      </Box>
      <Box sx={{ width: 80, height: 80, mr: 2, flexShrink: 0 }}>
        <img
          src={imageSrc}
          alt={item.title}
          onError={handleError}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack spacing={1} flex={1}>
          {/* 제목 */}
          <AlbumTitleLink
            title={item.title}
            contentRating={item.contentRating}
            lineClamp={3}
            sx={{
              fontSize: '14px',
            }}
            iconSx={{
              width: '12px',
              height: '12px',
              marginLeft: 0.5,
            }}
          />
          {/* 아이템 정보 */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body3" color={theme.palette.black[4]}>
              {item.artist?.name || item.artistName}
            </Typography>
            <Box>
              <Divider orientation="vertical" sx={{ height: 8 }} />
            </Box>
            <Typography variant="body3" color={theme.palette.black[4]}>
              {item.releaseDate}
            </Typography>
          </Stack>
        </Stack>

        {/* 삭제 버튼 */}
        <IconButton onClick={() => onRemove(item)} sx={{ width: '16px', height: '16px' }}>
          <CloseIcon sx={{ width: '16px', height: '16px', color: theme.palette.black[3] }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default SortableItem;
